import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { IProducto } from '../../../model/interface/IProducto';
import { ICertificacion } from '../../../model/interface/ICertificacion';
import { IArchivo } from '../../../model/interface/IArchivo';
import {ICodigoProducto} from '../../../model/interface/ICodigoProducto';
import { TokenCommonService } from '../token-common.service';
import { AuthService } from '../auth/auth.service';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class ProductoService extends TokenCommonService {

  producto: IProducto;
  productos: IProducto[] = [];
  productosPublicados: IProducto[] = [];
  productosSeleccionSF: IProducto[] = [];
  categorias: any[] = [];
  colores: any[] = [];
  certificaciones: ICertificacion[] = [];
  complementarios: IProducto[] = [];
  relacionados: IProducto[] = [];
  archivos: IArchivo[] = [];
  codigos: ICodigoProducto[] = [];
  categoriaActive: number = null;
  categoriaWasLoaded: Observable<any>;
  private categoriaWasLoadedSubject: Subject<any>;

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
    this.categoriaWasLoadedSubject = new Subject<any>();
    this.categoriaWasLoaded = this.categoriaWasLoadedSubject.asObservable();
  }


  get (id: number) {
    return this.http.get(`${ environment.API_URL }productos/${id}`)
      .map(res => {
        this.producto = res.json().data;

        return this.producto;
      });
  }

  getProducto (): IProducto {
    return this.producto;
  }

  getProductoCategorias (): any {
    return this.categorias;
  }

  setProductoCategoriaActive(categoria: number) {
    this.categoriaActive = categoria;
  }

  getProductoCategoriaActive() {
    return this.categoriaActive;
  }

  all () {
    return this.http.get(`${ environment.API_URL }productos`)
      .map(res => {
        this.productos = res.json().data;
        return this.productos;
      });
  }

  getPublicados (params?: any) {

    const requestParams = new URLSearchParams();
    const options = new RequestOptions({params: requestParams});

    if (typeof params !== 'undefined') {

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });
    }


    return this.http.get(`${ environment.API_URL }productos/publicados`, options)
      .map(res => {
        this.productosPublicados = res.json().data;

        return this.productosPublicados;
      });
  }

  getHistorialCambios (option: string, range: string) {    
      return this.http.get(`${ environment.API_URL }productos/historialCambios?option=${option}&range=${range}`)
      .map(res => {
        this.productosPublicados = res.json().data;

        return this.productosPublicados;
      });
  }

  getSeleccionSF () {
    return this.http.get(`${ environment.API_URL }productos/seleccionSF`)
      .map(res => {
        this.productosSeleccionSF = res.json().data;

        return this.productosSeleccionSF;
      });
  }

  getSeleccionSFBorradores () {
    return this.tokenGet(`${ environment.API_URL }productos/seleccionSFBorradores`);
  }

  getCategorias (id: number) {
    return this.http.get(`${ environment.API_URL }productos/${id}/categorias`)
      .map(res => {
        this.categorias = res.json().data;
        this.categoriaWasLoadedSubject.next(this.categorias);
        return this.categorias;
      });
  }

  getFichas (id: number) {
    return this.tokenGet(`${ environment.API_URL }productos/${id}/fichas`);
  }

  getColores (id: number) {
    return this.http.get(`${ environment.API_URL }productos/${id}/colores`)
      .map(res => {
        this.colores = res.json().data;

        return this.colores;
      });
  }

  getCertificaciones (id: number) {
    return this.http.get(`${ environment.API_URL }productos/${id}/certificaciones`)
      .map(res => {
        this.certificaciones = res.json().data;

        return this.certificaciones;
      });
  }

  getProductosComplementarios(id: number, params?: any) {

    const requestParams = new URLSearchParams();
    const options = new RequestOptions({params: requestParams});

    if (typeof params !== 'undefined') {

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });
    }


    return this.http.get(`${ environment.API_URL }productos/${id}/complementarios`, options)
      .map(res => {
        this.complementarios = res.json().data;

        return this.complementarios;
      });
  }

  getProductosRelacionados(id: number, params?: any) {

    const requestParams = new URLSearchParams();
    const options = new RequestOptions({params: requestParams});

    if (typeof params !== 'undefined') {

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });
    }


    return this.http.get(`${ environment.API_URL }productos/${id}/relacionados`, options)
      .map(res => {
        this.relacionados = res.json().data;

        return this.relacionados;
      });
  }

  getProductosAlternativos(id: number, params?: any) {
      const requestParams = new URLSearchParams();
      const options = new RequestOptions({params: requestParams});
  
      if (typeof params !== 'undefined') {
  
        _.forEach(params, (value, key) => {
          options.params.append(key, value);
        });
      }

    return this.http.get(`${ environment.API_URL }productos/${id}/alternativos`, options)
      .map(res => {
        this.productos = res.json().data;

        return this.productos;
      });
  }

  getArchivos(id: number) {

    return this.http.get(`${ environment.API_URL }productos/${id}/archivos`)
      .map(res => {
        this.archivos = res.json().data;

        return this.archivos;
      });
  }

  getCodigos(id: number) {

    return this.http.get(`${ environment.API_URL }productos/${id}/codigos`)
      .map(res => {
        this.codigos = res.json().data;

        return this.codigos;
      });
  }

  edit(id, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }productos/${id}`, data);
  }

  create(data: FormData) {
    return this.tokenPost(`${ environment.API_URL }productos`, data);
  }

  delete(id: number) {
    return this.tokenDelete(`${ environment.API_URL }productos/${id}`);
  }

  gatAll(params?: any) {
    return this.tokenGet(`${ environment.API_URL }productos/todos`, params);
  }

  descontinuar(id: number) {
    return this.tokenPost(`${ environment.API_URL }productos/${id}/descontinuar`);
  }

  setArchivo(id: number, archivo: FormData) {
    return this.tokenPost(`${ environment.API_URL }productos/${ id }/archivos`, archivo);
  }

  setColor(idProducto: number, idColor: number) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/colores/${idColor}`);
  }

  reemplaceColor(idProducto: number, data: any) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/colores`, data);
  }

  setCertificado(idProducto: number, idCertificado: number) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/certificaciones/${idCertificado}`);
  }

  reemplaceCertificados(idProducto: number, data: any) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/certificaciones`, data);
  }

  setProducotoComplementario(idProducto: number, idComplementario: number) {
    return this.tokenPut(`${ environment.API_URL }productos/${ idProducto }/complementarios/${idComplementario}`);
  }

  reemplaceProducotosComplementarios(idProducto: number, data: any) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/complementarios`, data);
  }

  reemplaceFichas(idProducto: number, data: any) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/fichas`, data);
  }

  setProducotoRelacionado(idProducto: number, idRelacionado: number) {
    return this.tokenPut(`${ environment.API_URL }productos/${ idProducto }/relacionados/${idRelacionado}`);
  }

  reemplaceProducotosRelacionados(idProducto: number, data: any) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/relacionados`, data);
  }

  setProductosAlternativos(idProducto: number, idAlternativo: number) {
    return this.tokenPut(`${ environment.API_URL }productos/${ idProducto }/alternativos/${idAlternativo}`);
  }

  reemplaceProductosAlternativos(idProducto: number, data: any) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/alternativos`, data);
  }

  deletaArchivo(idProducto: number, idArchivo: number) {
    return this.tokenDelete(`${ environment.API_URL }productos/${ idProducto }/archivos/${ idArchivo }`);
  }

  editArchivo(idProducto: number, idArchivo: number, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }productos/${ idProducto }/archivos/${ idArchivo }`, data);
  }

  reemplazarCodigos(idProducto: number, data: any[]) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/codigos`, data);
  }

  reemplaceCategories(idProducto: number, data: any) {
    return this.tokenPost(`${ environment.API_URL }productos/${ idProducto }/categorias`, data);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/producto/producto.service.ts